module.exports = __webpack_public_path__ + "static/4321-8a8089331ec1d6321ec88f115d6aebc9.jpeg";